import { render } from "./Loading.vue?vue&type=template&id=b88f78a4"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"

import "./Loading.vue?vue&type=style&index=0&id=b88f78a4&lang=css"

import exportComponent from "/Users/nick/programming/udemy_vue/IFA_loud/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__